import axios from 'axios';
import { ApiAvailability, ApiProperty, ApiRate, IProperty } from './types';

async function fetchAndProcess(propid: string): Promise<IProperty | undefined> {
  const { properties, availabilities, rates } = await fetchApiData();
  const property = properties.find((property) => property.propid === propid);
  const availability = availabilities.find(
    (availability) => availability.propid === propid
  );
  const rate = rates.find((rate) => rate.propid === propid);

  if (!property || !availability || !rate) return undefined;

  if (property.propgrpid !== '1006' && property.propgrpid !== '1012')
    return undefined;

  const processedData = processData(property, availability, rate);
  return processedData;
}

const processData = (
  property: ApiProperty,
  availability: ApiAvailability,
  rate: ApiRate
): IProperty => {
  const stdPeople = parseInt(property.stdpersons);
  const maxPeople = parseInt(property.maxpersons);
  return {
    ...property,
    ...availability,
    ...rate,
    minntslist: availability.minntslist.split(','),
    stdPeople: isNaN(stdPeople) ? 0 : stdPeople,
    maxPeople: isNaN(maxPeople) ? 0 : maxPeople,
  };
};

const fetchApiData = async () => {
  const apiMeta = document.head.querySelector('[property~=api-base][content]');

  if (!apiMeta || !(apiMeta instanceof HTMLMetaElement)) {
    throw 'API meta tag not found or invalid';
  }

  const apiBase = apiMeta.content;

  const { data: properties }: { data: ApiProperty[] } = await axios.get(
    `${apiBase}fetch/properties/json`,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    }
  );
  const { data: availabilities }: { data: ApiAvailability[] } = await axios.get(
    `${apiBase}fetch/availability/json`,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    }
  );
  const { data: rates }: { data: ApiRate[] } = await axios.get(
    `${apiBase}fetch/rates/json`,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    }
  );

  return { properties, availabilities, rates };
};

export { fetchAndProcess };
